/**
 * SS PDP testimonials — <ss-pdp-testimonials>
 * Native scroll-snap slider with bullets, arrows, keyboard, live status and
 * optional autoplay (paused on interaction, hidden tab, reduced motion).
 */
(function () {
  'use strict';
  if (customElements.get('ss-pdp-testimonials')) return;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class SsPdpTestimonials extends HTMLElement {
    constructor() { super(); this._listeners = []; this.index = 0; }

    connectedCallback() {
      this.track = this.querySelector('[data-ss-track]');
      this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
      this.bullets = Array.from(this.querySelectorAll('.swiper-pagination-bullet'));
      this.prev = this.querySelector('[data-ss-prev]');
      this.next = this.querySelector('[data-ss-next]');
      this.status = this.querySelector('[data-ss-status]');
      if (!this.track || !this.slides.length) return;
      this.bullets.forEach(function (b, i) { this.on(b, 'click', function () { this.goTo(i, true); }.bind(this)); }, this);
      if (this.prev) this.on(this.prev, 'click', function () { this.goTo(this.index - 1, true); }.bind(this));
      if (this.next) this.on(this.next, 'click', function () { this.goTo(this.index + 1, true); }.bind(this));
      this.on(this.track, 'keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.goTo(this.index + 1, true); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.goTo(this.index - 1, true); }
      }.bind(this));
      this.on(this.track, 'scroll', this.onScroll.bind(this), { passive: true });
      this.on(this.track, 'pointerdown', function () { this.userInteracted = true; }.bind(this));
      this.update(0);
      if (this.dataset.autoplay === 'true' && !reduced) {
        this.timer = setInterval(function () {
          if (this.userInteracted || document.hidden) return;
          var rect = this.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          this.goTo((this.index + 1) % this.slides.length, false);
        }.bind(this), parseInt(this.dataset.interval, 10) || 6000);
      }
    }

    disconnectedCallback() {
      this._listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
      this._listeners = [];
      if (this.timer) clearInterval(this.timer);
    }

    on(el, type, fn, opts) { el.addEventListener(type, fn, opts); this._listeners.push([el, type, fn, opts]); }

    goTo(i, byUser) {
      var target = Math.max(0, Math.min(this.slides.length - 1, i));
      if (byUser) this.userInteracted = true;
      var slide = this.slides[target];
      this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: reduced ? 'auto' : 'smooth' });
      this.update(target);
    }

    onScroll() {
      if (this._raf) return;
      this._raf = requestAnimationFrame(function () {
        this._raf = null;
        var left = this.track.scrollLeft;
        var best = 0, dist = Infinity;
        this.slides.forEach(function (slide, i) {
          var d = Math.abs(slide.offsetLeft - this.track.offsetLeft - left);
          if (d < dist) { dist = d; best = i; }
        }, this);
        if (best !== this.index) this.update(best);
      }.bind(this));
    }

    update(i) {
      this.index = i;
      this.slides.forEach(function (s, k) { s.classList.toggle('swiper-slide-active', k === i); });
      this.bullets.forEach(function (b, k) {
        b.classList.toggle('swiper-pagination-bullet-active', k === i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      if (this.status) this.status.textContent = this.slides[i].getAttribute('aria-label') || '';
      var maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prev) this.prev.disabled = i === 0;
      if (this.next) this.next.disabled = i === this.slides.length - 1 || this.track.scrollLeft >= maxScroll;
    }
  }

  customElements.define('ss-pdp-testimonials', SsPdpTestimonials);
})();
